
export const basicDetail =
[
  {
    name:"locationId",
     "rule": {
        "required": true
      },
    label:"Location",
    type:"dropdown"
  },
  {
    name:"date",
     "rule": {
        "required": true
      },
    label:"Date",
    type:"date"
  },
  {
    name:"hourStart",
     "rule": {
        "required": true
      },
    label:"Hour Start",
    type:"dropdown"
  },
  {
    name:"hourEnd",
     "rule": {
        "required": true
      },
    label:"Hour End",
    type:"dropdown"
  }
  
]

export const statusDD =
[
  { id:1, name:"Active"},
  { id:0, name:"Inactive"}
]
export const rateTypeFromDD =
[
  { id:1, name:"Exclusive"},
  { id:2, name:"Inclusive"}
]
export const editMode =
  [
    {
      name:"modTime",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod Time",
      type:"text"
    },
    {
      name:"modBy",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod By",
      type:"text"
    }
  ]

  export const HolidaysBreadcrumb = [
   
    {label:"Dashboard", path:"/dashboard"},
    {label:"Holidays", path:"/holidays"},
    {label:"Holidays", path:"#"},

]